import { PLATFORM_BRANDING } from '@src/utils/branding';
import { actionTypes } from './actions';

export const initialState = {
  colorSet: PLATFORM_BRANDING.colorSet,
  tenantCode: PLATFORM_BRANDING.tenantCode,
  brandName: PLATFORM_BRANDING.brandName,
  logo: PLATFORM_BRANDING.logo,
  favicon: PLATFORM_BRANDING.favicon,
};

export default function changeThemeReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CHANGE_THEME: {
      const { colorSet } = action;

      return {
        ...state,
        colorSet,
      };
    }

    case actionTypes.SET_BRANDING: {
      const { branding } = action;

      return {
        ...state,
        ...branding,
      };
    }

    case actionTypes.RESET_BRANDING:
      return {
        ...state,
        colorSet: PLATFORM_BRANDING.colorSet,
        tenantCode: PLATFORM_BRANDING.tenantCode,
        brandName: PLATFORM_BRANDING.brandName,
        logo: PLATFORM_BRANDING.logo,
        favicon: PLATFORM_BRANDING.favicon,
      };

    default:
      return state;
  }
}
